export default "__VITE_ASSET__bZFYlPR___"